export default function(number, config) { 
  return (number || 0).toLocaleString(config.locale, {style: 'currency', currency: config.currency, currencyDisplay: 'symbol', minimumFractionDigits: 2, maximumFractionDigits: 2})
}